<template>
  <el-dialog
    title="Disponibilizar Imóvel para Aluguel"
    :visible.sync="visibility"
    :before-close="fechar"
    :close-on-click-modal="false"
    append-to-body
    v-loading="isLoading"
    @open="reset"
    width="30%"
  >
    <el-form :model="disponibilizarAluguel" :rules="validacao" ref="form" size="small" label-position="top" style="margin-bottom: 20px;">
      <el-col :span="12">
        <el-form-item label="Valor Aluguel" prop="valorAluguel">
          <div class="el-input el-input--small">
            <money 
              v-model="disponibilizarAluguel.valorAluguel"
              v-bind="money"
              class="el-input__inner"
            />
          </div>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="Taxa de Adm.">
          <div class="el-input el-input--small">
            <money
              v-model="disponibilizarAluguel.comissao"
              v-bind="percent"
              class="el-input__inner"
            />
          </div>
        </el-form-item>
      </el-col>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="disponibilizarAluguelHandler" type="primary" size="small" round class="btn-box-shadow">
        Confirmar
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { Money } from "v-money";
import { mapState, mapActions } from 'vuex';

export default {
  props: {
    visibility: Boolean
  },

  components: {
    Money,
  },

  data() {
    return {
      disponibilizarAluguel: {
        imovel: {id: 0},
        valorAluguel: 0,
        comissao: 0
      },

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },

      percent: {
        decimal: ",",
        thousands: ".",
        suffix: " %",
        precision: 2,
        masked: false
      },

      validacao: {
        valorAluguel: [{ type: "number", min: 0.01 , message: "Min:0.01"}],
      }
    }
  },
  
  computed: {
    ...mapState({
      isLoading(state) { return state.loading; }
    }),

    ...mapState('vendasImoveisStore', {
      imovel(state) { return state.imovelSelecionado; }
    })
  },

  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("vendasImoveisStore", [
      "disponibilizarAluguelImovel"
    ]),

    disponibilizarAluguelHandler() {
      this.$refs["form"].validate(valid => {
        if(valid) {
          this.disponibilizarParaAluguel();
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      });
    },

    disponibilizarParaAluguel() {
      this.showLoading();

      this.disponibilizarAluguelImovel( {...this.disponibilizarAluguel, imovel: {id: this.imovel.id}} )
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.fechar();
            break;
          case "FALHA":
          case "ERRO":
            this.$message({
              message: resultado.mensagem,
              type: 'warning',
              duration: 10000});
            this.fechar();
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível comunicar-se com o servidor");
      })
    },

    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    },

    reset() {
      this.disponibilizarAluguel = {
        imovel: {id: 0},
        valorAluguel: 0
      }
    },

    fechar() {
      this.$refs["form"].resetFields();
      this.$emit("close");
    }
  }
}
</script>